import { UserRole } from "@fuse/recoil/pluginStudio/types"

import { ExamplePlugin } from "../types"
import { GUEST_VIEW } from "./guest_view"
import { HOST_CONFIG_VIEW } from "./host_config"
import { HOST_VIEW } from "./host_view"
import { SEARCH_VIEW } from "./search_view"

export const openDoorExperiment: ExamplePlugin = {
  id: "open-door",
  name: "Open door experiment",
  description: "Create different open door experiments for hosts",
  category: "Communication",
  tags: ["intermediate", "messages", "feedback"],
  difficulty: "intermediate",
  preview: "Open door experiments",
  files: {
    [UserRole.GUEST]: GUEST_VIEW,
    [UserRole.HOST_EVENT_VIEW]: HOST_VIEW,
    [UserRole.HOST_CONFIG_VIEW]: HOST_CONFIG_VIEW,
    search: SEARCH_VIEW,
  },
}
